import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "49.95",
  width: "50",
  viewBox: "0 0 50 49.95",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M30.39 17.402h-9.477V7.924h-3.51v9.478h-9.48v3.51h9.48v9.48h3.51v-9.48h9.478"
  }), /*#__PURE__*/_jsx("path", {
    d: "M33.9 31.344c2.76-3.31 4.364-7.573 4.364-12.187C38.314 9.93 30.994 0 19.157 0 8.577 0 0 8.576 0 19.157s8.576 19.158 19.157 19.158c4.664 0 8.977-1.705 12.287-4.464l16.098 16.1L50 47.49 33.9 31.344zm-14.743 3.46c-8.625 0-15.646-7.02-15.646-15.647S10.535 3.51 19.16 3.51c9.68 0 15.647 8.125 15.647 15.647 0 8.626-7.02 15.647-15.647 15.647z"
  })]
});